import * as React from 'react';
import { PropsWithChildren } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    GetBrandConfig,
    TenantActionCreators,
} from '../Store/Tenant';

import { CreateStdTheme } from '../Utils/Style';
import { Theme, ThemeProvider } from '@mui/material/styles';

import { GetTenantName } from '../Store/Tenant';

import { ApplicationState } from '../Store';

import { PortalTextCommon } from '../Models/Api/strongbox.financialportal';
import { GetPortalText } from '../Store/PortalAssets';
import { StringFormat } from '../Utils/StringUtils';
import { GetTenantFaviconPath } from '../Utils/BrandUtils';

type InjectedReduxState = {
    faviconTitle: string;
    activeTheme: Theme;
    tenantName: string;
};

type InjectedActionCreators = typeof TenantActionCreators;

type PortalHeaderProps = {
};

type Props = InjectedReduxState & InjectedActionCreators & PortalHeaderProps;

const WrapperComponent: React.FC<Props & PropsWithChildren> = (props): React.ReactElement => {
    const {
        tenantName,
        faviconTitle,
    } = props;

    const [faviconPath, setFaviconPath] = React.useState<string | undefined>(undefined);

    React.useEffect(() => {
        GetTenantFaviconPath(tenantName)
            .then((path) => {
                setFaviconPath(path);
            });

        // nothing needed in dependencies want this to run on initial load.
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, []);

    React.useEffect(() => {
        if (!!faviconPath) {
            let link = document.querySelector('link[rel="shortcut icon"]') ||
                document.querySelector('link[rel="icon"]');

            if (link) {
                const attr = document.createAttribute("href");
                attr.value = faviconPath;
                link.attributes.setNamedItem(attr);
            }
        }

        // nothing needed in dependencies beyond faviconPath
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [faviconPath]);

    React.useEffect(() => {
            let titleComponent = document.querySelector('title');
            if (titleComponent) {
                titleComponent.innerText = faviconTitle;
                titleComponent.innerHTML = faviconTitle;
            }
        },
        [faviconTitle]
    );

    return (
        <div>
            <ThemeProvider theme={props.activeTheme} >
                {props.children}
            </ThemeProvider>
        </div>
    );
}

export const Wrapper = connect<InjectedReduxState, InjectedActionCreators, PortalHeaderProps, ApplicationState>(
    (appState: ApplicationState,) => {
        const tenantName = GetTenantName(appState);
        const brandConfig = GetBrandConfig(appState);
        const commonText = GetPortalText<PortalTextCommon>(appState, 'commonText');

        return {
            faviconTitle: StringFormat(commonText?.faviconTitle || '{0}', GetTenantName(appState)),
            activeTheme: CreateStdTheme(brandConfig),
            tenantName
        };
    },
    dispatch => bindActionCreators(
        {
            ...TenantActionCreators,
        },
        dispatch
    )
)(WrapperComponent);
